// @flow
'use strict';

import * as React from 'react';
import { FormSection } from 'redux-form/lib/immutable';

import SelecaoTodosNfe from '../../form_exportacao_nfe/campos_nfe/selecao_todos_nfe';
import { Input } from '../../../../../../common/input';

type CamposItemProps = {
  component : React.ComponentType<*>,
}

export default function CamposDocumentoReferenciado({ component } : CamposItemProps) {
  const SelecaoTodos = component || SelecaoTodosNfe;

  return (
      <FormSection name="dadosItemDocumentoReferenciado">
        <SelecaoTodos nomes={ ["dadosItemDocumentoReferenciado"] } titulo="Documento Referenciado"/>

        <div className="grupo-checkbox">
          <Input name="chaveDfeReferenciado" label="Chave do DF-e Referenciado" checkbox/>
          <Input name="itemReferenciado" label="Item Referenciado" checkbox/>
        </div>
      </FormSection>
  );
}